var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rabbey-table-4',{attrs:{"url":_vm.indexUrl,"columns":_vm.columns}})
}
var staticRenderFns = []

export { render, staticRenderFns }